import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/logo-transparent.png'
import _imports_1 from '../../assets/profile.svg'


const _withScopeId = n => (_pushScopeId("data-v-19e9a6f5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "fixed top-0 z-50 w-full bg-white border-b border-gray-200" }
const _hoisted_2 = { class: "px-4 lg:px-6 py-3 flex items-center justify-between" }
const _hoisted_3 = { class: "flex items-center gap-3" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "w-5 h-5",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M4 6h16M4 12h16M4 18h16"
  })
], -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "h-8 w-8",
  alt: "GEMA Logo"
}, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-[#1E2833] font-extrabold text-sm uppercase tracking-wide hidden sm:block" }, "G.E.M.A", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "hidden sm:block px-1.5 py-0.5 bg-[#6CC551]/10 text-[#6CC551] text-xs font-bold rounded" }, "Admin", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "w-7 h-7 rounded-full",
  src: _imports_1,
  alt: "user"
}, null, -1))
const _hoisted_10 = { class: "hidden sm:block text-sm font-semibold text-[#1E2833]" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "w-4 h-4 text-gray-400",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M19 9l-7 7-7-7"
  })
], -1))
const _hoisted_12 = { class: "absolute right-0 mt-2 w-44 bg-white rounded-xl border border-gray-100 shadow-lg py-1 z-10" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "my-1 border-t border-gray-100" }, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "h-0.5 bg-[#6CC551]" }, null, -1))
const _hoisted_15 = { class: "h-full px-3 py-4 overflow-y-auto" }
const _hoisted_16 = { class: "space-y-1" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "w-4 h-4 flex-shrink-0",
  fill: "currentColor",
  viewBox: "0 0 20 20"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M2 10a8 8 0 018-8v8h8a8 8 0 11-16 0z" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M12 2.252A8.014 8.014 0 0117.748 8H12V2.252z" })
], -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "px-3 pt-4 pb-1 text-xs font-bold uppercase tracking-widest text-gray-500" }, "Content", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "w-4 h-4 flex-shrink-0",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
  })
], -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "flex-1 text-left" }, "Posts", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M19 9l-7 7-7-7"
}, null, -1))
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = {
  key: 0,
  class: "mt-1 space-y-0.5 pl-9"
}
const _hoisted_25 = ["onClick"]
const _hoisted_26 = ["onClick"]
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "w-4 h-4 flex-shrink-0",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M3 7a2 2 0 012-2h4l2 2h6a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2V7z"
  })
], -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "flex-1 text-left" }, "Documents", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M19 9l-7 7-7-7"
}, null, -1))
const _hoisted_30 = [
  _hoisted_29
]
const _hoisted_31 = {
  key: 0,
  class: "mt-1 space-y-0.5 pl-9"
}
const _hoisted_32 = ["onClick"]
const _hoisted_33 = ["onClick"]
const _hoisted_34 = ["onClick"]
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "w-4 h-4 flex-shrink-0",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
  })
], -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "flex-1 text-left" }, "Slider", -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M19 9l-7 7-7-7"
}, null, -1))
const _hoisted_38 = [
  _hoisted_37
]
const _hoisted_39 = {
  key: 0,
  class: "mt-1 space-y-0.5 pl-9"
}
const _hoisted_40 = ["onClick"]
const _hoisted_41 = ["onClick"]
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "w-4 h-4 flex-shrink-0",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
  })
], -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "flex-1 text-left" }, "Departments & Units", -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M19 9l-7 7-7-7"
}, null, -1))
const _hoisted_45 = [
  _hoisted_44
]
const _hoisted_46 = {
  key: 0,
  class: "mt-1 space-y-0.5 pl-9"
}
const _hoisted_47 = ["onClick"]
const _hoisted_48 = ["onClick"]

import { onMounted, computed, ref, onBeforeUnmount } from "vue";
import { useStore } from "vuex";
import { isRouteActive } from "@/functions/index";
import router from "@/router";


export default /*#__PURE__*/_defineComponent({
  __name: 'AdminPage',
  setup(__props) {

const store          = useStore();
const isLoading      = ref(false);
const isSidebarOpen  = ref(true);
const openAccordion  = ref<string | null>(null);
const isDropdownOpen = ref(false);
const dropdownRef    = ref<HTMLElement | null>(null);

const handleClickOutside = (event: MouseEvent) => {
  if (dropdownRef.value && !dropdownRef.value.contains(event.target as Node)) {
    isDropdownOpen.value = false;
  }
};

onMounted(() => {
  sessionStorage.setItem("username", storeUsername.value);
  document.addEventListener("click", handleClickOutside);
});

onBeforeUnmount(() => {
  document.removeEventListener("click", handleClickOutside);
});

const storeUsername = computed(() => store.getters.username);
const username = sessionStorage.getItem("username") || storeUsername.value;

const toggleSidebar   = () => { isSidebarOpen.value = !isSidebarOpen.value; };
const toggleAccordion = (key: string) => {
  openAccordion.value = openAccordion.value === key ? null : key;
};

const logout = async () => {
  try {
    isLoading.value = true;
    await store.dispatch("logout");
    router.push("/login");
  } finally {
    isLoading.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("nav", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            onClick: toggleSidebar,
            type: "button",
            class: "p-2 rounded-lg text-gray-500 hover:bg-gray-100 transition-colors"
          }, _hoisted_5),
          _createVNode(_component_router_link, {
            to: "/admin/dashboard",
            class: "flex items-center gap-2"
          }, {
            default: _withCtx(() => [
              _hoisted_6,
              _hoisted_7,
              _hoisted_8
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", {
          class: "relative",
          ref_key: "dropdownRef",
          ref: dropdownRef
        }, [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (isDropdownOpen.value = !isDropdownOpen.value)),
            type: "button",
            class: "flex items-center gap-2 px-3 py-2 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-100 transition-colors"
          }, [
            _hoisted_9,
            _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(username)), 1),
            _hoisted_11
          ]),
          _createVNode(_Transition, {
            "enter-active-class": "transition ease-out duration-100",
            "enter-from-class": "transform opacity-0 scale-95",
            "enter-to-class": "transform opacity-100 scale-100",
            "leave-active-class": "transition ease-in duration-75",
            "leave-from-class": "transform opacity-100 scale-100",
            "leave-to-class": "transform opacity-0 scale-95"
          }, {
            default: _withCtx(() => [
              _withDirectives(_createElementVNode("div", _hoisted_12, [
                _createVNode(_component_router_link, {
                  to: "/admin/add-user",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (isDropdownOpen.value = false)),
                  class: "flex items-center gap-2 px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 hover:text-[#6CC551] transition-colors"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Add User ")
                  ]),
                  _: 1
                }),
                _hoisted_13,
                _createElementVNode("button", {
                  onClick: _cache[2] || (_cache[2] = ($event: any) => {logout(); isDropdownOpen.value = false}),
                  class: "flex items-center gap-2 w-full px-4 py-2 text-sm text-red-500 hover:bg-red-50 transition-colors"
                }, _toDisplayString(isLoading.value ? 'Signing out…' : 'Sign Out'), 1)
              ], 512), [
                [_vShow, isDropdownOpen.value]
              ])
            ]),
            _: 1
          })
        ], 512)
      ])
    ]),
    _createElementVNode("aside", {
      class: _normalizeClass([
    'fixed top-0 left-0 z-40 w-64 h-screen pt-14 transition-transform duration-300 ease-in-out bg-[#1E2833]',
    isSidebarOpen.value ? 'translate-x-0' : '-translate-x-full'
  ])
    }, [
      _hoisted_14,
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("ul", _hoisted_16, [
          _createVNode(_component_router_link, {
            to: "/admin/dashboard",
            custom: ""
          }, {
            default: _withCtx(({ navigate }) => [
              _createElementVNode("li", null, [
                _createElementVNode("button", {
                  onClick: navigate,
                  class: _normalizeClass(['flex items-center gap-3 w-full px-3 py-2.5 rounded-lg text-sm font-medium transition-colors',
                _unref(isRouteActive)('/admin/dashboard')
                  ? 'bg-[#6CC551] text-white'
                  : 'text-gray-300 hover:bg-white/10 hover:text-white'])
                }, [
                  _hoisted_18,
                  _createTextVNode(" Dashboard ")
                ], 10, _hoisted_17)
              ])
            ]),
            _: 1
          }),
          _hoisted_19,
          _createElementVNode("li", null, [
            _createElementVNode("button", {
              onClick: _cache[3] || (_cache[3] = ($event: any) => (toggleAccordion('posts'))),
              class: _normalizeClass(['flex items-center gap-3 w-full px-3 py-2.5 rounded-lg text-sm font-medium transition-colors',
              openAccordion.value === 'posts' ? 'bg-white/10 text-white' : 'text-gray-300 hover:bg-white/10 hover:text-white'])
            }, [
              _hoisted_20,
              _hoisted_21,
              (_openBlock(), _createElementBlock("svg", {
                class: _normalizeClass(['w-4 h-4 transition-transform duration-200', openAccordion.value === 'posts' ? 'rotate-180' : '']),
                fill: "none",
                stroke: "currentColor",
                viewBox: "0 0 24 24"
              }, _hoisted_23, 2))
            ], 2),
            (openAccordion.value === 'posts')
              ? (_openBlock(), _createElementBlock("ul", _hoisted_24, [
                  _createVNode(_component_router_link, {
                    to: "/admin/new-post",
                    custom: ""
                  }, {
                    default: _withCtx(({ navigate }) => [
                      _createElementVNode("li", null, [
                        _createElementVNode("button", {
                          onClick: navigate,
                          class: _normalizeClass(['w-full text-left px-3 py-2 rounded-lg text-sm transition-colors',
                    _unref(isRouteActive)('/admin/new-post') ? 'bg-[#6CC551] text-white font-medium' : 'text-gray-400 hover:text-white hover:bg-white/10'])
                        }, " New Post ", 10, _hoisted_25)
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_router_link, {
                    to: "/admin/view-posts",
                    custom: ""
                  }, {
                    default: _withCtx(({ navigate }) => [
                      _createElementVNode("li", null, [
                        _createElementVNode("button", {
                          onClick: navigate,
                          class: _normalizeClass(['w-full text-left px-3 py-2 rounded-lg text-sm transition-colors',
                    _unref(isRouteActive)('/admin/view-posts') ? 'bg-[#6CC551] text-white font-medium' : 'text-gray-400 hover:text-white hover:bg-white/10'])
                        }, " View Posts ", 10, _hoisted_26)
                      ])
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("button", {
              onClick: _cache[4] || (_cache[4] = ($event: any) => (toggleAccordion('documents'))),
              class: _normalizeClass(['flex items-center gap-3 w-full px-3 py-2.5 rounded-lg text-sm font-medium transition-colors',
              openAccordion.value === 'documents' ? 'bg-white/10 text-white' : 'text-gray-300 hover:bg-white/10 hover:text-white'])
            }, [
              _hoisted_27,
              _hoisted_28,
              (_openBlock(), _createElementBlock("svg", {
                class: _normalizeClass(['w-4 h-4 transition-transform duration-200', openAccordion.value === 'documents' ? 'rotate-180' : '']),
                fill: "none",
                stroke: "currentColor",
                viewBox: "0 0 24 24"
              }, _hoisted_30, 2))
            ], 2),
            (openAccordion.value === 'documents')
              ? (_openBlock(), _createElementBlock("ul", _hoisted_31, [
                  _createVNode(_component_router_link, {
                    to: "/admin/add-document",
                    custom: ""
                  }, {
                    default: _withCtx(({ navigate }) => [
                      _createElementVNode("li", null, [
                        _createElementVNode("button", {
                          onClick: navigate,
                          class: _normalizeClass(['w-full text-left px-3 py-2 rounded-lg text-sm transition-colors',
                    _unref(isRouteActive)('/admin/add-document') ? 'bg-[#6CC551] text-white font-medium' : 'text-gray-400 hover:text-white hover:bg-white/10'])
                        }, " Add Document ", 10, _hoisted_32)
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_router_link, {
                    to: "/admin/document-categories",
                    custom: ""
                  }, {
                    default: _withCtx(({ navigate }) => [
                      _createElementVNode("li", null, [
                        _createElementVNode("button", {
                          onClick: navigate,
                          class: _normalizeClass(['w-full text-left px-3 py-2 rounded-lg text-sm transition-colors',
                    _unref(isRouteActive)('/admin/document-categories') ? 'bg-[#6CC551] text-white font-medium' : 'text-gray-400 hover:text-white hover:bg-white/10'])
                        }, " Categories ", 10, _hoisted_33)
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_router_link, {
                    to: "/admin/view-documents",
                    custom: ""
                  }, {
                    default: _withCtx(({ navigate }) => [
                      _createElementVNode("li", null, [
                        _createElementVNode("button", {
                          onClick: navigate,
                          class: _normalizeClass(['w-full text-left px-3 py-2 rounded-lg text-sm transition-colors',
                    _unref(isRouteActive)('/admin/view-documents') ? 'bg-[#6CC551] text-white font-medium' : 'text-gray-400 hover:text-white hover:bg-white/10'])
                        }, " View Documents ", 10, _hoisted_34)
                      ])
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("button", {
              onClick: _cache[5] || (_cache[5] = ($event: any) => (toggleAccordion('sliders'))),
              class: _normalizeClass(['flex items-center gap-3 w-full px-3 py-2.5 rounded-lg text-sm font-medium transition-colors',
              openAccordion.value === 'sliders' ? 'bg-white/10 text-white' : 'text-gray-300 hover:bg-white/10 hover:text-white'])
            }, [
              _hoisted_35,
              _hoisted_36,
              (_openBlock(), _createElementBlock("svg", {
                class: _normalizeClass(['w-4 h-4 transition-transform duration-200', openAccordion.value === 'sliders' ? 'rotate-180' : '']),
                fill: "none",
                stroke: "currentColor",
                viewBox: "0 0 24 24"
              }, _hoisted_38, 2))
            ], 2),
            (openAccordion.value === 'sliders')
              ? (_openBlock(), _createElementBlock("ul", _hoisted_39, [
                  _createVNode(_component_router_link, {
                    to: "/admin/add-slider",
                    custom: ""
                  }, {
                    default: _withCtx(({ navigate }) => [
                      _createElementVNode("li", null, [
                        _createElementVNode("button", {
                          onClick: navigate,
                          class: _normalizeClass(['w-full text-left px-3 py-2 rounded-lg text-sm transition-colors',
                    _unref(isRouteActive)('/admin/add-slider') ? 'bg-[#6CC551] text-white font-medium' : 'text-gray-400 hover:text-white hover:bg-white/10'])
                        }, " Add Slider ", 10, _hoisted_40)
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_router_link, {
                    to: "/admin/view-sliders",
                    custom: ""
                  }, {
                    default: _withCtx(({ navigate }) => [
                      _createElementVNode("li", null, [
                        _createElementVNode("button", {
                          onClick: navigate,
                          class: _normalizeClass(['w-full text-left px-3 py-2 rounded-lg text-sm transition-colors',
                    _unref(isRouteActive)('/admin/view-sliders') ? 'bg-[#6CC551] text-white font-medium' : 'text-gray-400 hover:text-white hover:bg-white/10'])
                        }, " View Sliders ", 10, _hoisted_41)
                      ])
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("button", {
              onClick: _cache[6] || (_cache[6] = ($event: any) => (toggleAccordion('departments'))),
              class: _normalizeClass(['flex items-center gap-3 w-full px-3 py-2.5 rounded-lg text-sm font-medium transition-colors',
              openAccordion.value === 'departments' ? 'bg-white/10 text-white' : 'text-gray-300 hover:bg-white/10 hover:text-white'])
            }, [
              _hoisted_42,
              _hoisted_43,
              (_openBlock(), _createElementBlock("svg", {
                class: _normalizeClass(['w-4 h-4 transition-transform duration-200', openAccordion.value === 'departments' ? 'rotate-180' : '']),
                fill: "none",
                stroke: "currentColor",
                viewBox: "0 0 24 24"
              }, _hoisted_45, 2))
            ], 2),
            (openAccordion.value === 'departments')
              ? (_openBlock(), _createElementBlock("ul", _hoisted_46, [
                  _createVNode(_component_router_link, {
                    to: "/admin/add-department",
                    custom: ""
                  }, {
                    default: _withCtx(({ navigate }) => [
                      _createElementVNode("li", null, [
                        _createElementVNode("button", {
                          onClick: navigate,
                          class: _normalizeClass(['w-full text-left px-3 py-2 rounded-lg text-sm transition-colors',
                    _unref(isRouteActive)('/admin/add-department') ? 'bg-[#6CC551] text-white font-medium' : 'text-gray-400 hover:text-white hover:bg-white/10'])
                        }, " Add Department ", 10, _hoisted_47)
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_router_link, {
                    to: "/admin/view-departments",
                    custom: ""
                  }, {
                    default: _withCtx(({ navigate }) => [
                      _createElementVNode("li", null, [
                        _createElementVNode("button", {
                          onClick: navigate,
                          class: _normalizeClass(['w-full text-left px-3 py-2 rounded-lg text-sm transition-colors',
                    _unref(isRouteActive)('/admin/view-departments') ? 'bg-[#6CC551] text-white font-medium' : 'text-gray-400 hover:text-white hover:bg-white/10'])
                        }, " View Departments ", 10, _hoisted_48)
                      ])
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ], 2),
    _createElementVNode("main", {
      class: _normalizeClass(['pt-14 min-h-screen bg-gray-50 transition-all duration-300', isSidebarOpen.value ? 'lg:ml-64' : 'ml-0'])
    }, [
      _createVNode(_Transition, {
        name: "fade",
        mode: "out-in"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_router_view)
        ]),
        _: 1
      })
    ], 2)
  ], 64))
}
}

})